export enum MembersEditRights {
    None = 0,
    OwnItems = 1
}
